export default {"src":"/_next/static/media/hero.c689c738.svg","height":576,"width":587,"blurWidth":0,"blurHeight":0};